import { utilsModule } from "../utils-module";

utilsModule.controller('rightMenuController', ['$scope','$rootScope', '$state','$mdSidenav',function($scope, $rootScope, $state,$mdSidenav){	
	let isMenuOpen = true;

	$rootScope.$on("hideRightMenu", () =>{ $scope.hideMenu()})
	$rootScope.$on("showRightMenu", () =>{ $scope.showMenu()})
	/*
	 * Show the right menu
	 */
	$scope.showMenu = function(){
		isMenuOpen = true;
		return $mdSidenav('right').open();
	};

	/*
	 * Hides the right Menu
	 */
	$scope.hideMenu = function(){
		isMenuOpen = false;
		return $mdSidenav('right').close();
	};

	/*
	 * Toggle the right menu
	 */
	$scope.toggleMenu = function(){
		return $mdSidenav('right').toggle();
	};	

	/**
	 * Controls the menu visibility
	 */
	$scope.isVisible = function(){
		return (<any>window).$("#no-rightbar").length <= 0;
	};

	/*
	 * Returns if menu is open
	 */
	$scope.isOpen = function(){
		return isMenuOpen;
	}

	/**
	 * Returns the current location
	 */
	$scope.getLocation = function(){
		return $state.current.name;
	};

	
}]);